﻿import { Routes } from '@angular/router';

import { HomeComponent } from './_components/public/home';
import { LoginComponent, ChangePasswordComponent, SocialComponent } from './_components/public/login';
import { RegisterComponent } from './_components/public/register';
import { UserGuard, RootGuard } from './_guards';
import { RestComponent } from './_components/root/rest';
import { UsersComponent, EditUserComponent } from './_components/root/users';
import { ParamsComponent, EditParamComponent } from './_components/root/params';
import { ResultadosComponent, RecordComponent } from './_components/public/tablas';
import { ResultadoUserComponent } from './_components/user/tablas';
import { CasaUserComponent } from './_components/user/tablas/casa.component';
import { CategoriaUserComponent } from './_components/user/tablas/categoria.component';
import { CategoriaDeporteUserComponent } from './_components/user/tablas/categoriaDeporte.component';
import { DeporteUserComponent } from './_components/user/tablas/deporte.component';
import { PuestoUserComponent } from './_components/user/tablas/puesto.component';
import { AlumnoUserComponent } from './_components/user/tablas/alumno.component';
import { SexoUserComponent } from './_components/user/tablas/sexo.component';
import { GradoUserComponent } from './_components/user/tablas/grado.component';
import { RecordUserComponent } from './_components/user/tablas/record.component';
import { HomeRootComponent } from './_components/root/home';
import { InterHousesUserComponent } from './_components/user/tablas/interhouses.component';
import { CargarResultadoComponent } from './_components/user/cargarResultado/cargar.resultado.component';
import { CargarInterhouseComponent } from './_components/user/cargarInterhouse/cargar.interhouse.component';
import { ResumenComponent } from './_components/user/resumen/resumen.component';
import { CargarInterHousesUserComponent } from './_components/user/tablas/cargar.interhouses.component';
import { PuntosComponent } from './_components/user/puntos/puntos.component';
import { RootResultadoComponent } from './_components/root/resultado/resultado.component';
import { GradoRootComponent } from './_components/root/grado';

export const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'change', component: ChangePasswordComponent },
    { path: 'oauth', component: SocialComponent },
    { path: 'resultado', component: ResultadosComponent },
    { path: 'record', component: RecordComponent },
    { path: 'home', component: HomeComponent },


    {
        path: 'user', canActivateChild: [UserGuard],
        children: [            
            { path: 'resultado', component: ResultadoUserComponent },
            { path: 'casa', component: CasaUserComponent },
            { path: 'categoria', component: CategoriaUserComponent },
            { path: 'categoriadeporte', component: CategoriaDeporteUserComponent },
            { path: 'deporte', component: DeporteUserComponent },
            { path: 'puesto', component: PuestoUserComponent },
            { path: 'alumno', component: AlumnoUserComponent },
            { path: 'sexo', component: SexoUserComponent },
            { path: 'grado', component: GradoUserComponent },
            { path: 'record', component: RecordUserComponent },
            { path: 'interhouses', component: InterHousesUserComponent },
            { path: 'cargarResultado', component: CargarResultadoComponent },
            { path: 'resumen', component: ResumenComponent },
            { path: 'cargarInterhouses', component: CargarInterHousesUserComponent },
            { path: 'cargarInterhouse', component: CargarInterhouseComponent },
            { path: 'puntos', component: PuntosComponent }

        ]
    },
    {
        path: 'root', canActivateChild: [RootGuard],
        children: [
            { path: 'rest', component: RestComponent },
            { path: 'home', component: HomeRootComponent },
            { path: 'resultados', component: RootResultadoComponent },
            { path: 'grado', component: GradoRootComponent},            
            {
                path: 'users', children: [
                    { path: '', component: UsersComponent },
                    { path: ':id', component: EditUserComponent }
                ]
            },
            {
                path: 'params', children: [
                    { path: '', component: ParamsComponent },
                    { path: ':id', component: EditParamComponent }
                ]
            }

        ]
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: '**', redirectTo: '' }

];
